{
    "name": "sesamm-tool-web",
    "version": "1.18.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --ssl --ssl-cert %APPDATA%\\ASP.NET\\https\\%npm_package_name%.pem --ssl-key %APPDATA%\\ASP.NET\\https\\%npm_package_name%.key",
        "build": "ng build",
        "build-dev": "ng build -c=development",
        "build-prod": "ng build -c=production",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "prestart": "node aspnetcore-https",
        "lint": "ng lint",
        "prettier-write": "prettier --write src/.",
        "prettier-check": "prettier --check src/."
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.2.8",
        "@angular/cdk": "^21.2.6",
        "@angular/common": "^21.2.8",
        "@angular/compiler": "^21.2.8",
        "@angular/core": "^21.2.8",
        "@angular/forms": "^21.2.8",
        "@angular/platform-browser": "^21.2.8",
        "@angular/platform-browser-dynamic": "^21.2.8",
        "@angular/router": "^21.2.8",
        "@ngrx/effects": "^21.1.0",
        "@ngrx/operators": "^21.1.0",
        "@ngrx/router-store": "^21.1.0",
        "@ngrx/store": "^21.1.0",
        "@ngrx/store-devtools": "^21.1.0",
        "@primeuix/themes": "^2.0.3",
        "@tailwindcss/postcss": "^4.2.2",
        "aws-jwt-verify": "^5.1.1",
        "d3": "^7.9.0",
        "docx": "^9.6.1",
        "elkjs": "^0.11.1",
        "file-saver": "^2.0.5",
        "jest-editor-support": "*",
        "jszip": "^3.10.1",
        "postcss": "^8.5.9",
        "primeicons": "^7.0.0",
        "primeng": "^21.1.5",
        "rxjs": "^7.8.2",
        "tailwindcss": "^4.2.2",
        "tailwindcss-primeui": "^0.6.1",
        "tslib": "^2.8.1",
        "zone.js": "~0.16.1"
    },
    "devDependencies": {
        "@angular-eslint/builder": "^21.3.1",
        "@angular-eslint/eslint-plugin": "^21.3.1",
        "@angular-eslint/eslint-plugin-template": "^21.3.1",
        "@angular-eslint/schematics": "^21.3.1",
        "@angular-eslint/template-parser": "^21.3.1",
        "@angular/build": "^21.2.7",
        "@angular/cli": "~21.2.7",
        "@angular/compiler-cli": "^21.2.8",
        "@types/d3": "^7.4.3",
        "@types/file-saver": "^2.0.7",
        "@types/jasmine": "~6.0.0",
        "@typescript-eslint/eslint-plugin": "^8.58.1",
        "@typescript-eslint/parser": "^8.58.1",
        "eslint": "^8.57.1",
        "jasmine-core": "~4.3.0",
        "karma": "~6.4.4",
        "karma-chrome-launcher": "~3.1.1",
        "karma-coverage": "~2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.0.0",
        "prettier": "^3.8.1",
        "typescript": "~5.9.3"
    }
}
